// extracted by mini-css-extract-plugin
export default {"button":"buttons_button__p8UFn","button_outline":"buttons_button_outline__ItTcv"};